import type { SWRConfiguration } from 'swr'

/** SWR global config following spec §6.2 */
export const swrConfig: SWRConfiguration = {
  refreshInterval: 60_000,
  dedupingInterval: 10_000,
  revalidateOnFocus: true,
  revalidateIfStale: true,
  shouldRetryOnError: true,
  errorRetryCount: 3,
  errorRetryInterval: 5_000,
  keepPreviousData: true,
}

/**
 * A generic JSON fetcher for SWR (no schema, raw unknown).
 */
export async function genericFetcher(url: string): Promise<unknown> {
  const res = await fetch(url, { headers: { Accept: 'application/json' } })
  if (!res.ok) throw new Error(`${res.status} ${res.statusText} — ${url}`)
  return res.json()
}

/**
 * Standard fetcher for typed SWR hooks.
 */
export async function fetcher<T>(url: string): Promise<T> {
  const res = await fetch(url, { headers: { Accept: 'application/json' } })
  if (!res.ok) throw new Error(`${res.status} ${res.statusText} — ${url}`)
  return res.json() as Promise<T>
}
